import { SizeChartData } from '@components/pages/static/SizeChart'
import axios from 'axios'

const sizeChartByProductTypeQuery = `query SizeChartQuery($product_type: String!) {
  sizeChart(product_type: $product_type) {
    items {
      build
      cut
      leg
      measurements {
        key
        value
      }
      product_measurement_type
      product_type
    }
  }
}`

export const getSizeChart = async (
  productType: string
): Promise<{ sizeChart: SizeChartData }> => {
  const { data } = await axios({
    method: 'post',
    url: `https://${process.env.CONTENT_API_DOMAIN}/graphql`,
    headers: {
      Accept: 'application/json',
      'x-api-key': process.env.CONTENT_API_API_KEY!
    },
    data: {
      query: sizeChartByProductTypeQuery,
      variables: { product_type: productType }
    }
  })

  return data.data
}
